import { Controller } from "@hotwired/stimulus"

// AT-1113: verplichte velden nakijken zodra je ze verlaat.
//
// Bewust géén betaalknop die uitgaat tot alles klopt. Die knop kan niet vertellen wát er
// mist, en op dit formulier zijn dat er vijf plus twee vormregels (geldig e-mailadres,
// bevestiging die overeenkomt). Een dode knop laat de bezoeker zoeken; de melding onder
// het veld zegt het meteen. Dat verschilt van de bestelknop op de ticketstap: daar is de
// oorzaak zichtbaar -- alles staat op nul -- en valt er niets uit te leggen.
//
// De servervalidatie blijft leidend. Dit haalt de melding alleen naar voren, zodat je hem
// krijgt bij het veld in plaats van na een volledige paginalading.
export default class extends Controller {
  static targets = ["input", "error"]
  static values = { required: String, email: String, confirm: String, postcode: String, postcodeFormats: Object, postcodeCountries: Array }

  check(event) {
    this.#beoordeel(event.target)
  }

  // AT-1394: een ander land kan een ingevulde postcode goed of fout maken. Alleen een
  // postcode die er al staat opnieuw beoordelen; een leeg veld blijft ongemoeid.
  // AT-1414: behalve als er al een fout staat. Een verplichte postcode die leeg is mag
  // bij een land zonder postcode (zie #postcodeVerplicht) weer zonder melding.
  checkPostcode(event) {
    const veld = event.target.closest(".field")?.querySelector('[name="customer[postcode_area]"]')
    if (veld && (veld.value.trim() !== "" || this.#veldHeeftFout(veld))) this.#beoordeel(veld)
  }

  // Tijdens typen alleen opruimen, nooit een nieuwe fout tonen: iemand die net begint te
  // typen krijgt anders "ongeldig e-mailadres" na één letter.
  herstel(event) {
    const veld = event.target
    if (!this.#veldHeeftFout(veld)) return
    if (this.#fout(veld) === null) this.#toon(veld, null)
  }

  #beoordeel(veld) {
    this.#toon(veld, this.#fout(veld))
  }

  #fout(veld) {
    const waarde = (veld.value || "").trim()
    const naam = veld.name || ""

    if (veld.required && waarde === "") return this.requiredValue

    if (waarde === "" && this.#postcodeVerplicht(veld)) return this.requiredValue

    if (waarde === "") return null

    if (naam.includes("[email]") && !this.#geldigMail(waarde)) return this.emailValue

    if (naam.includes("[postcode_area]") && !this.#geldigePostcode(veld, waarde)) return this.postcodeValue

    if (naam.includes("[email_confirm]")) {
      const mail = this.element.querySelector('[name="customer[email]"]')
      if (mail && mail.value.trim() !== "" && mail.value.trim() !== waarde) return this.confirmValue
    }

    return null
  }

  // Bewust ruim: de server valideert streng, dit is alleen om een duidelijke typefout
  // -- geen apenstaartje, geen punt -- meteen te melden.
  #geldigMail(waarde) {
    return /\S+@\S+\.\S+/.test(waarde)
  }

  // AT-1394: de vorm per land komt van de server (PostcodeArea::INPUT_FORMATS), zodat de
  // regels op één plek staan. Een land zonder vaste vorm is altijd goed.
  #geldigePostcode(veld, waarde) {
    const vorm = this.postcodeFormatsValue[this.#land(veld)]
    return !vorm || new RegExp(vorm).test(waarde.toUpperCase().replace(/\s/g, ""))
  }

  // AT-1414: een verplichte postcodevraag vraagt alleen een postcode bij de landen waar
  // we er een van bewaren (PostcodeArea::POSTCODE_COUNTRIES); daarbuiten is het land
  // genoeg. Daarom geen required-attribuut op het veld maar deze controle op het land.
  #postcodeVerplicht(veld) {
    if (!veld.dataset.postcodeRequired) return false
    return this.postcodeCountriesValue.map(String).includes(this.#land(veld))
  }

  #land(veld) {
    return veld.closest(".field")?.querySelector('[name="customer[postcode_country]"]')?.value || "172"
  }

  #veldHeeftFout(veld) {
    const blok = veld.closest(".field")
    return blok ? blok.classList.contains("field--invalid") : false
  }

  #toon(veld, boodschap) {
    const blok = veld.closest(".field")
    if (!blok) return
    const melding = blok.querySelector(".field__error")
    if (!melding) return

    blok.classList.toggle("field--invalid", Boolean(boodschap))
    melding.hidden = !boodschap
    if (boodschap) melding.querySelector("span").textContent = boodschap
  }
}
